import { useEffect } from 'react';
import type { CanonicalPrivateEvent, PrivateEventName } from '@/lib/realtime/contracts';
import type { Source } from './private-event-bus';
import { usePrivateEventBus } from './use-private-event-bus';

/**
 * Subscribes the component to a private event by name. Handler receives the
 * canonical payload and the transport source that won the policy decision.
 *
 * Mount inside a {@link PrivateEventBusProvider}. The handler subscription is
 * cleaned up on unmount.
 */
export function useRealtimePrivateEvent<E extends PrivateEventName>(
  name: E,
  handler: (payload: CanonicalPrivateEvent<E>, source: Source) => void,
): void {
  const bus = usePrivateEventBus();
  useEffect(() => {
    return bus.on(name, (e) => handler(e.payload, e.source));
  }, [bus, name, handler]);
}
